import PropTypes from 'prop-types';

export default PropTypes.shape({
  version: PropTypes.string.isRequired,
  timestamp: PropTypes.oneOfType([
    PropTypes.number.isRequired,
    PropTypes.string.isRequired
  ]).isRequired,
  md5: PropTypes.string.isRequired,
  status: PropTypes.oneOf([
    'ACTIVE',
    'PENDING_APPROVAL',
    'BETA',
    'ALPHA',
    'RETIRED',
    'DELETED'
  ])
});



// WEBPACK FOOTER //
// ./src/shapes/product-version.js